import {Controller} from "@hotwired/stimulus";

export default class GymFormController extends Controller {
  static values = {
    gymName: String,
  }

  static targets = [
    "formError", 'zoneOption', "map",
    "precioClaseExtra", "precioClaseExtraInput",
    "latitudeInput", "longitudeInput"
  ]

  initialize() {
    this.setZonesByCity();
    this.initMap();
  }

  toggleExtraClasses(event) {
    if(event.target.checked) {
      this.precioClaseExtraTarget.classList.remove('d-none');
    } else {
      this.precioClaseExtraTarget.classList.add('d-none');
    }

    this.precioClaseExtraInputTarget.required = event.target.checked;
  }

  get citySelect() {
    return this.element['gym[city_id]'];
  }

  /**
   *
   * @returns {HTMLSelectElement}
   */
  get zoneSelect() {
    return this.element['gym[zone_id]'];
  }

  async initMap() {

    // The location of Uluru
    const position = {
      lat: this.latitudeInputTarget.value ? parseFloat(this.latitudeInputTarget.value, 10) : 19.425305,
      lng: this.longitudeInputTarget.value ? parseFloat(this.longitudeInputTarget.value, 10) : -99.194775,
    };

    console.debug(
      "Gym - Form, Init map",
      `name=${this.gymNameValue}, lat=${this.latitudeValue}, lon=${this.longitudeValue}`
    );
    console.debug("Gym - Form, Init map", position);

    // Request needed libraries.
    //@ts-ignore
    const {Map} = await google.maps.importLibrary("maps");
    const {AdvancedMarkerElement} = await google.maps.importLibrary("marker");

    // The map, centered at Uluru
    const map = new Map(this.mapTarget, {
      zoom: 14,
      center: position,
      mapId: "DEMO_MAP_ID",
    });

    // The marker, positioned at Uluru
    const marker = new AdvancedMarkerElement({
      map: map,
      position: position,
      title: this.gymNameValue,
      gmpDraggable: true,
    });

    marker.addListener("dragend", (event) => {
      console.debug("=> Marker Dropped:", marker.position, event);

      this.latitudeInputTarget.value = marker.position.lat;
      this.longitudeInputTarget.value = marker.position.lng;
    });
  }

  setZonesByCity() {
    const cityId = this.citySelect.value;
    console.debug("Current city value", cityId);

    if (this.zoneSelect.selectedOptions.length > 0) {
      const zoneOption = this.zoneSelect.selectedOptions[0];
      console.log("Current Option", zoneOption);
    }

    for (const option of this.zoneSelect.options) {
      if (option.dataset.cityId === cityId) {
        option.style.display = 'block';
      } else {
        if (option.selected) {
          option.selected = false;
        }
        option.style.display = 'none';
      }
    }
  }
}
